import template from './ppsrButton.template.html';
import templateSearch from './ppsr.template.html';

export default {
  template,
  bindings: {
    asset: '<',
    idTicket: '<',
    isDisabled: '<',
    onChange: '&'
  },
  controller: class controller {
    constructor($rootScope, $mdDialog, $mdMedia, ppsrService, eventService, uiService, PPSR) {
      'ngInject';

      const ctrl = this;
      ctrl.$mdMedia = $mdMedia;

      ctrl.initialize = () => {
        ctrl.asset = ctrl.asset || {};
        ctrl.idTicket = ctrl.idTicket || '';
        ctrl.isDisabled = ctrl.isDisabled || false;
      };

      ctrl.openDialog = ($event) => {
        $event.stopPropagation();
        $mdDialog
          .show({
            targetEvent: $event,
            locals: {
              currentOrganization: $rootScope.CurrentOrganization,
              asset: ctrl.asset,
              availableSerialNumberTypes: PPSR.SERIAL_NUMBER_TYPES,
              idTicket: ctrl.idTicket
            },
            template: templateSearch,
            controllerAs: '$ctrl',
            multiple: true,
            controller(currentOrganization, asset, availableSerialNumberTypes, idTicket) {
              const self = this;
              self.asset = asset;
              self.organization = currentOrganization;
              self.vinChassis = asset.vehicle.vinChassis;
              self.availableSerialNumberTypes = availableSerialNumberTypes;
              self.idTicket = idTicket;
              self.serialNumberType = 2;
              self.errorMessages = [];
              self.hasError = false;
              self.isLoading = false;

              self.isValid = () => self.vinChassis.length === 17;

              self.confirm = () => {
                if (self.isValid()) {
                  self.errorMessages = [];
                  self.hasError = false;
                  self.isLoading = true;
                  ppsrService
                    .search({
                      idTicket: self.idTicket || '',
                      idAssetToBeFinanced: asset?.id || '',
                      serialNumber: self.vinChassis || '',
                      serialNumberType: self.serialNumberType || ''
                    })
                    .then((result) => {
                      self.isLoading = false;
                      if (result.status) {
                        self.asset.additionalInfo.ppsr.summary = result?.summary || [];
                        eventService.assetDetailsAdditionalInfo();
                        $mdDialog.hide({ asset: self.asset });
                      } else {
                        self.hasError = true;
                        if (result?.errors?.length) {
                          const len = result?.errors?.length || 0;
                          for (let e = 0; e < len; e += 1) {
                            const error = result?.errors[e];
                            const message = error?.label
                              ? `${error?.label?.sanitize()} -> ${error?.message || ''}`
                              : error?.message || error || '';
                            self.errorMessages.push(message);
                          }
                        } else {
                          self.errorMessages.push(result?.errorMessage);
                        }
                        self.errorMessages.unshift('PPSR errors:');
                      }
                    });
                }
              };

              self.cancel = () => {
                $mdDialog.cancel();
              };
            }
          })
          .then((result) => {
            if (result?.asset) {
              ctrl.onChange({ asset: result.asset });
            }
          });
      };

      ctrl.$onInit = () => {
        ctrl.initialize();
      };
    }
  }
};
